import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/seanrioux/products/open-source-okr/code/react-okr-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contribution-guide"
    }}>{`Contribution guide`}</h1>
    <h2 {...{
      "id": "git"
    }}>{`Git`}</h2>
    <p>{`Contributors should work from the latest version branch in development (indicated using format `}<inlineCode parentName="p">{`v0.1.0`}</inlineCode>{`).`}</p>
    <p>{`Pull requests will be reviewed for contribution to future releases.`}</p>
    <h2 {...{
      "id": "development"
    }}>{`Development`}</h2>
    <p>{`The easiest way to get started is via the included Docz site. Docz is a React based static site generator for documentation. It uses mdx.`}</p>
    <p>{`Using Docz we have components in a living style guide. To run Docz locally for development:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install
npm run docz:dev
`}</code></pre>
    <p>{`To run a build of the Docz site:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm run docz:build
`}</code></pre>
    <p>{`To build and serve a Docz site:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm run docz:serve
`}</code></pre>
    <h2 {...{
      "id": "build"
    }}>{`Build`}</h2>
    <p>{`Builds for distribution are via Webpack. To test your builds, you can:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm run build
`}</code></pre>
    <p>{`Builds are distributed via npm.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      